var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socialwall container"},[_vm._v("SocialWall")])}
var staticRenderFns = []

export { render, staticRenderFns }